import { useAuthStore } from "../../store/authStore";

export default function MyProfile() {
  const user = useAuthStore((s) => s.user) || {};
  const roleLabel =
    (user.role_name || "").toLowerCase() === "group_admin"
      ? "Group Admin"
      : "Centre Admin";

  const Row = ({ label, value }) => (
    <div className="d-flex justify-content-between py-2 border-bottom">
      <span className="text-muted">{label}</span>
      <span className="fw-semibold">{value || "—"}</span>
    </div>
  );

  return (
    <div className="row g-3">
      <div className="col-12 col-lg-6">
        <div className="card">
          <div className="card-header"><strong>My Profile</strong></div>
          <div className="card-body">
            <Row label="Name" value={user.full_name} />
            <Row label="Email" value={user.email} />
            <Row label="Phone" value={user.phone} />
            <Row label="Role" value={roleLabel} />
            <Row label="Centre" value={user.centre_name || "All centres"} />
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-6">
        <div className="card">
          <div className="card-header"><strong>Access</strong></div>
          <div className="card-body">
            <p className="text-muted mb-0">
              {roleLabel === "Group Admin"
                ? "You have full access across all centres."
                : "Your access is limited to your assigned centre's families, submissions and uploads."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
